import { Link } from 'react-router-dom';
import { useState } from 'react';

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="bg-cyber-dark border-b border-gray-800 sticky top-0 z-50 backdrop-blur-lg bg-opacity-90">
      <nav className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-gradient-to-br from-cyber-blue to-cyber-purple rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-xl">V</span>
            </div>
            <span className="text-xl font-bold gradient-text">Velumcloud</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/vpn" className="text-gray-300 hover:text-cyber-blue transition-colors">
              VPN
            </Link>
            <Link to="/casb" className="text-gray-300 hover:text-cyber-blue transition-colors">
              CASB
            </Link>
            <Link to="/about" className="text-gray-300 hover:text-cyber-blue transition-colors">
              About
            </Link>
            <Link to="/contact" className="btn-primary">
              Contact Us
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <svg className="w-6 h-6" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
              {mobileMenuOpen ? (
                <path d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-4">
            <Link 
              to="/vpn" 
              className="block text-gray-300 hover:text-cyber-blue transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              VPN
            </Link>
            <Link 
              to="/casb" 
              className="block text-gray-300 hover:text-cyber-blue transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              CASB
            </Link>
            <Link 
              to="/about" 
              className="block text-gray-300 hover:text-cyber-blue transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              About
            </Link>
            <Link 
              to="/contact" 
              className="block btn-primary text-center"
              onClick={() => setMobileMenuOpen(false)}
            >
              Contact Us
            </Link>
          </div>
        )}
      </nav>
    </header>
  );
}

export default Header;
